<template>
  <span
    class="app-avatar"
    :class="{ 'app-avatar--40': px >= 40, 'app-avatar--ring': ring }"
    :style="sizeStyle"
    aria-hidden="true"
  >{{ initials }}</span>
</template>

<script>
// Avatar (Spezifikation 2.6): Kreis #eceff3 mit Initialen #3a4250 600 (11 px bei 28, 16 px bei 40).
// Initialen: erster Buchstabe des ersten und letzten Wortes, bei einem Wort die ersten zwei (gen_r3.py:250–252).
// ring: weiß mit Ring #d9dde3 auf getönten Flächen (Auswahlzeile, Seitenleiste, Rail, Fensterfläche).
export function initialsOf(name) {
  const text = String(name || '').trim();
  if (!text) {
    return '';
  }
  const parts = text.split(/\s+/);
  if (parts.length > 1) {
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
  return text.slice(0, 2).toUpperCase();
}

export default {
  name: 'AppAvatar',
  props: {
    name: { type: String, default: '' },
    size: { type: [Number, String], default: 28 },
    ring: { type: Boolean, default: false }
  },
  computed: {
    px() {
      return Number(this.size) || 28;
    },
    initials() {
      return initialsOf(this.name);
    },
    sizeStyle() {
      if (this.px === 28 || this.px === 40) {
        return null;
      }
      return { width: this.px + 'px', height: this.px + 'px' };
    }
  }
};
</script>
